/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function AmexLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <AmexLogo.Outline {...props} />
  ) : (
    <AmexLogo.Solid {...props} />
  );
}

AmexLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

AmexLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <mask
          id="mask0_1435_214"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="70"
          height="48"
        >
          <rect width="70" height="48" fill="#016FD0" />
        </mask>
        <g mask="url(#mask0_1435_214)">
          <rect width="70" height="48" rx="4" fill="#016FD0" />
          <path
            d="M13.6152 36.7205V25.708H25.2755L26.5265 27.3389L27.8189 25.708H70.1426V35.9611C70.1426 35.9611 69.0358 36.7095 67.7556 36.7205H44.3201L42.9096 34.9846V36.7205H38.2876V33.7572C38.2876 33.7572 37.6563 34.1708 36.2913 34.1708H34.7181V36.7205H27.7199L26.4707 35.0547L25.2023 36.7205H13.6152Z"
            fill="white"
          />
          <path
            d="M0 17.4084L2.62943 11.2783H7.17674L8.66898 14.7122V11.2783H14.3217L15.21 13.7602L16.0712 11.2783H41.4462V12.526C41.4462 12.526 42.7801 11.2783 44.9723 11.2783L53.2056 11.3071L54.6721 14.696V11.2783H59.4026L60.7045 13.225V11.2783H65.4784V22.2908H60.7045L59.4568 20.3379V22.2908H52.5066L51.8077 20.5549H49.9393L49.2517 22.2908H44.5384C42.652 22.2908 41.4462 21.0686 41.4462 21.0686V22.2908H34.3396L32.9291 20.5549V22.2908H6.50309L5.80463 20.5549H3.94215L3.24864 22.2908H0V17.4084Z"
            fill="white"
          />
          <path
            d="M3.55824 12.6357L0.0117188 20.8816H2.32069L2.97507 19.2304H6.77927L7.43026 20.8816H9.79008L6.24695 12.6357H3.55824ZM4.87039 14.5548L6.02996 17.4402H3.70743L4.87039 14.5548Z"
            fill="#016FD0"
          />
          <path
            d="M10.0352 20.8796V12.6338L13.3163 12.646L15.2248 17.9624L17.0875 12.6338H20.3424V20.8796H18.281V14.8037L16.0958 20.8796H14.2879L12.0966 14.8037V20.8796H10.0352Z"
            fill="#016FD0"
          />
          <path
            d="M21.7539 20.8797V12.6338H28.4808V14.4783H23.8371V15.8888H28.3723V17.6247H23.8371V19.0895H28.4808V20.8797H21.7539Z"
            fill="#016FD0"
          />
          <path
            d="M29.6719 12.6357V20.8817H31.7334V17.9522H32.6013L35.0731 20.8817H37.5923L34.8798 17.8437C35.993 17.7498 37.1413 16.7943 37.1413 15.3109C37.1413 13.5757 35.7794 12.6357 34.2593 12.6357H29.6719ZM31.7334 14.4802H34.0898C34.6551 14.4802 35.0663 14.9224 35.0663 15.3482C35.0663 15.896 34.5335 16.2162 34.1203 16.2162H31.7334V14.4802Z"
            fill="#016FD0"
          />
          <path
            d="M40.0912 20.8797H37.9863V12.6338H40.0912V20.8797Z"
            fill="#016FD0"
          />
          <path
            d="M45.0811 20.8797H44.6267C42.4284 20.8797 41.0938 19.1478 41.0938 16.7906C41.0938 14.3753 42.4135 12.6338 45.1896 12.6338H47.4681V14.5868H45.1063C43.9793 14.5868 43.1824 15.4662 43.1824 16.811C43.1824 18.4079 44.0937 19.0786 45.4066 19.0786H45.9491L45.0811 20.8797Z"
            fill="#016FD0"
          />
          <path
            d="M49.568 12.6357L46.0215 20.8816H48.3305L48.9848 19.2304H52.789L53.44 20.8816H55.7998L52.2567 12.6357H49.568ZM50.8802 14.5548L52.0397 17.4402H49.7172L50.8802 14.5548Z"
            fill="#016FD0"
          />
          <path
            d="M56.0391 20.8797V12.6338H58.66L62.0065 17.8146V12.6338H64.068V20.8797H61.5318L58.1005 15.5633V20.8797H56.0391Z"
            fill="#016FD0"
          />
          <path
            d="M15.0273 35.3104V27.0645H21.7543V28.9089H17.1105V30.3194H21.6458V32.0554H17.1105V33.5201H21.7543V35.3104H15.0273Z"
            fill="#016FD0"
          />
          <path
            d="M47.9883 35.3104V27.0645H54.7152V28.9089H50.0715V30.3194H54.585V32.0554H50.0715V33.5201H54.7152V35.3104H47.9883Z"
            fill="#016FD0"
          />
          <path
            d="M22.0155 35.3103L25.2908 31.2382L21.9375 27.0645H24.5347L26.5317 29.6447L28.5355 27.0645H31.031L27.7218 31.1874L31.0031 35.3103H28.4063L26.4673 32.7708L24.5754 35.3103H22.0155Z"
            fill="#016FD0"
          />
          <path
            d="M31.2461 27.0654V35.3113H33.3618V32.7074H35.5318C37.3679 32.7074 38.7596 31.7333 38.7596 29.8389C38.7596 28.2697 37.6681 27.0654 35.7997 27.0654H31.2461ZM33.3618 28.9303H35.6471C36.2402 28.9303 36.6643 29.2938 36.6643 29.8796C36.6643 30.4299 36.2424 30.829 35.6403 30.829H33.3618V28.9303Z"
            fill="#016FD0"
          />
          <path
            d="M39.6562 27.0645V35.3104H41.7177V32.3809H42.5857L45.0575 35.3104H47.5767L44.8642 32.2724C45.9774 32.1784 47.1257 31.223 47.1257 29.7396C47.1257 28.0044 45.7638 27.0645 44.2437 27.0645H39.6562ZM41.7177 28.9089H44.0742C44.6395 28.9089 45.0507 29.3511 45.0507 29.7769C45.0507 30.3248 44.5179 30.6449 44.1047 30.6449H41.7177V28.9089Z"
            fill="#016FD0"
          />
          <path
            d="M55.67 35.3104V33.5201H59.7956C60.4061 33.5201 60.6704 33.1903 60.6704 32.8285C60.6704 32.4818 60.4069 32.1314 59.7956 32.1314H57.9313C56.3107 32.1314 55.4082 31.144 55.4082 29.6616C55.4082 28.3395 56.2347 27.0645 58.6428 27.0645H62.6573L61.7893 28.9198H58.3173C57.6536 28.9198 57.4493 29.268 57.4493 29.6006C57.4493 29.9425 57.7018 30.3194 58.2088 30.3194H60.1618C61.9683 30.3194 62.7522 31.3441 62.7522 32.686C62.7522 34.1287 61.8787 35.3104 60.0635 35.3104H55.67Z"
            fill="#016FD0"
          />
          <path
            d="M63.2344 35.3104V33.5201H67.3601C67.9705 33.5201 68.2349 33.1903 68.2349 32.8285C68.2349 32.4818 67.9714 32.1314 67.3601 32.1314H65.4957C63.8752 32.1314 62.9727 31.144 62.9727 29.6616C62.9727 28.3395 63.7992 27.0645 66.2073 27.0645H70.1397L69.3537 28.9198H65.8818C65.2181 28.9198 65.0138 29.268 65.0138 29.6006C65.0138 29.9425 65.2663 30.3194 65.7733 30.3194H67.7263C69.5328 30.3194 70.3167 31.3441 70.3167 32.686C70.3167 34.1287 69.4432 35.3104 67.6279 35.3104H63.2344Z"
            fill="#016FD0"
          />
        </g>
      </>
    ),
  });

  return <Icon viewBox="0 0 70 48" {...validateKeys(props)} />;
};
